import React from 'react'
import { Route } from 'react-router'

const TodoList = React.lazy(() => import('./components/list/todo-list'))

const todoRoutes = (
  <>
    <Route path='todos/:id?' Component={TodoList} />
    <Route path='todos/new/customer/:customerId' Component={TodoList} />
  </>
)

export default todoRoutes
